import type { RubricDetailDto } from '@sara/api-client';
import type { RubricFormValues } from './schemas';

/**
 * Maps a rubric's latest version into editable form values.
 * Returns undefined when the rubric has no versions.
 */
export function rubricToFormValues(rubric: RubricDetailDto): RubricFormValues | undefined {
  const latestVersion = rubric.versions[0];
  if (!latestVersion) return undefined;

  return {
    name: rubric.name,
    description: rubric.description ?? '',
    dimensions: latestVersion.dimensions.map((d) => ({
      key: d.key,
      name: d.name,
      description: d.description ?? undefined,
      weight: d.weight,
      anchors: {
        low: d.anchors.low,
        mid: d.anchors.mid,
        high: d.anchors.high,
      },
    })),
    bands: latestVersion.bands.map((b) => ({
      label: b.label,
      min: b.min,
    })),
    flags: (latestVersion.flags ?? []).map((f) => ({
      key: f.key,
      name: f.name,
      category: f.category,
      guidance: f.guidance,
      note: f.note ?? undefined,
    })),
  };
}
